import { render, staticRenderFns } from "./ProgramCreationDateDistributionGraph.vue?vue&type=template&id=0876077d"
import script from "./ProgramCreationDateDistributionGraph.vue?vue&type=script&lang=js"
export * from "./ProgramCreationDateDistributionGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports